import { Button } from '@hometap/htco-components';
import './FinalApproveButton.scss';
import React from 'react';
import { useMutation } from '@apollo/client';
import { APPROVE_TRACK } from '../../../../data/mutations/approveTrack';
import { showNotification, TOAST_TYPE } from 'utils/toasts';
import { useParams } from 'react-router-dom';
import { getGraphQLError } from 'utils/errors';

type FinalApproveButtonProps = {
  disabled: boolean;
  visible: boolean;
  onSuccess?: () => void;
};

export const FinalApproveButton = ({ disabled, visible, onSuccess }: FinalApproveButtonProps) => {
  const { trackId } = useParams();

  const [approveTrackMutation, { loading }] = useMutation(APPROVE_TRACK, {
    onCompleted: () => {
      onSuccess?.();
      showNotification({
        type: TOAST_TYPE.success,
        title: 'Application successfully approved',
        description: 'Your application has been approved.',
      });
    },
    onError: error =>
      showNotification({
        type: TOAST_TYPE.error,
        title: 'Failed to approve',
        description: getGraphQLError(error) || 'Could not approve. Please try again.',
      }),
  });

  const onFinalApproveButtonClick = () => approveTrackMutation({ variables: { trackId: trackId } });

  if (!trackId || !visible) {
    return null;
  }

  return (
    <Button
      className="FinalApproveButton"
      size="small"
      loading={loading}
      onClick={onFinalApproveButtonClick}
      disabled={disabled}
    >
      Final approve
    </Button>
  );
};
